
import { css } from 'lit';
export default css`
:host{
  display:block;
}

.color{
  box-shadow:var(--shadow);
}

.palette{
  height:var(--spacing-12);
}

.content{
  padding:var(--spacing-4);
  display:flex;
  flex-direction:column;
  gap:var(--spacing-2);
}
`;